import { useState } from "react";
import { Skeleton } from "@mui/material";

const ImageSkeleton = ({ src, alt, height }) => {
  const [loading, setLoading] = useState(true);

  return (
    <>
      {loading && (
        <Skeleton 
          variant="rectangular" 
          width="100%" 
          height={height} 
          animation="wave" 
        />
      )}

      <img
        src={src}
        alt={alt}
        style={{
          width: "100%",
          height: `${height}px`,
          objectFit: "cover",
          display: loading ? "none" : "block",
        }}
        onLoad={() => setLoading(false)}
        onError={() => setLoading(false)}
      />
    </>
  );
};

export default ImageSkeleton;
